export default function checkAuthMethod() {
	const memberAuthInfo = window.BUYANDSHIP.settings.member_auth
	return {
		isSupportEmailLogin: memberAuthInfo.basic_login === 'yes',
		isSupportFacebookLogin:
			memberAuthInfo.social_login !== undefined &&
			memberAuthInfo.social_login.facebook !== undefined,
		isSupportGoogleLogin:
			memberAuthInfo.social_login !== undefined &&
			memberAuthInfo.social_login.google !== undefined,
		isSupportAppleLogin:
			memberAuthInfo.social_login !== undefined &&
			memberAuthInfo.social_login.apple !== undefined,
	}
}
